import { Popover } from 'antd';
import type { PopoverProps } from 'antd';
import React from 'react';

/**
 * AppPopover Component
 *
 * Ant Design Popover wrapper following Atomic Design principles.
 * Extends all Ant Design Popover props.
 *
 * The panel is portalled to `document.body`, so page-scoped CSS does not reach
 * it. Pass `classNames={{ root: ... }}` when the panel has to inherit a scope's
 * styling or design tokens.
 */

export type AppPopoverProps = PopoverProps;

const AppPopover: React.FC<AppPopoverProps> = props => {
  return <Popover {...props} />;
};

AppPopover.displayName = 'AppPopover';

export default AppPopover;
